import React, { useEffect, useState, ReactNode, forwardRef } from "react";
import clsx from "clsx";

interface AppModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  title?: string;
  custom?: boolean;
  preventOutsideClick?: boolean;
  hideCloseButton?: boolean;
}

const AppModal = forwardRef<HTMLDivElement, AppModalProps>(
  ({ isOpen, onClose, children, title, custom = false, preventOutsideClick = false, hideCloseButton = false }, ref) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
      const handleResize = () => setIsMobile(window.innerWidth <= 768);
      window.addEventListener("resize", handleResize);

      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []);

    if (!isOpen) return null;

    return (
      <div
        className="fixed inset-0 z-[70] flex items-center justify-center bg-black bg-opacity-50"
        onClick={preventOutsideClick ? undefined : onClose}
      >
        <div
          ref={ref}
          onClick={(e) => e.stopPropagation()}
          className={clsx(
            "bg-white rounded-lg shadow-lg p-4 transition-transform transform",
            custom ? "w-auto" : "w-[400px]",
            isMobile && "w-[calc(100%-64px)]"
          )}
        >
          <div className="flex justify-between items-center mb-4">
            {title && <h2 className="text-lg font-semibold">{title}</h2>}
            <button
              className="text-gray-600 hover:text-gray-800"
              onClick={onClose}
            >
              {hideCloseButton ? '' : '✕'}
            </button>
          </div>
          {children}
        </div>
      </div>
    );
  }
);

AppModal.displayName = "AppModal";

export default AppModal;